module.exports = "<div>{{ ::vm.receiver.name }}</div> <div>{{ ::vm.receiver.addressLine }}</div> <div>{{ ::vm.receiver.postalCode }} {{ ::vm.receiver.cityName }}</div> <div class=type-xsmall> <span translate>parcel.licenseNumberShort</span> {{ ::vm.receiver.licenseNumber }} </div>";


//////////////////
// WEBPACK FOOTER
// ./features/account/parcels/components/parcel-receiver-detail.html
// module id = 552
// module chunks = 0